import { Facebook, IosShare, LinkRounded, WhatsApp, X } from '@mui/icons-material';
import { Button } from '@mui/material';
import copy from 'copy-to-clipboard';
import { logEvent } from 'firebase/analytics';
import { useDispatch, useSelector } from 'react-redux';
import { analyticsInstanceSelector } from '../../services/GameSlice';
import { setBody, setType } from '../../services/NotificationSlice';

const popup = (href) => window.open(href, 'share', 'width=640,height=580');

/**
 * One row of ways to pass a link on. `kind` ('challenge' | 'result' | 'invite')
 * is only used to tell the shares apart in analytics.
 */
const ShareButtons = ({ url, text, kind, itemId, tone }) => {
    const dispatch = useDispatch();
    const analytics = useSelector(analyticsInstanceSelector);

    const track = (method) => {
        if (analytics) {
            logEvent(analytics, 'share', { method, content_type: kind, item_id: itemId });
        }
    };

    const options = [
        {
            key: 'facebook',
            label: 'Facebook',
            icon: <Facebook />,
            color: '#1877F2',
            onClick: () => popup(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`)
        },
        {
            key: 'whatsapp',
            label: 'WhatsApp',
            icon: <WhatsApp />,
            color: '#1FAF55',
            onClick: () => popup(`https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`)
        },
        {
            key: 'x',
            label: 'Post',
            icon: <X fontSize="small" />,
            color: '#111111',
            onClick: () => popup(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`)
        },
        {
            key: 'copy',
            label: 'Copy link',
            icon: <LinkRounded />,
            outlined: true,
            onClick: () => {
                copy(url);
                dispatch(setType('success'));
                dispatch(setBody('Link copied'));
            }
        }
    ];

    // The system share sheet reaches Messenger, Instagram and the rest, where
    // the browser has one.
    if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
        options.push({
            key: 'native',
            label: 'More',
            icon: <IosShare />,
            outlined: true,
            onClick: () => navigator.share({ title: 'Play Sequence', text, url }).catch(() => { /* dismissed */ })
        });
    }

    return (
        <div className="share-buttons">
            {options.map(option => (
                <Button
                    key={option.key}
                    variant={option.outlined ? 'outlined' : 'contained'}
                    startIcon={option.icon}
                    onClick={() => {
                        track(option.key);
                        option.onClick();
                    }}
                    sx={option.outlined
                        ? (tone === 'dark'
                            ? { color: '#F3EEE2', borderColor: 'rgba(243, 238, 226, 0.3)' }
                            : { color: 'text.primary', borderColor: 'rgba(22, 32, 28, 0.25)' })
                        : { backgroundColor: option.color, color: '#fff', '&:hover': { backgroundColor: option.color, filter: 'brightness(1.1)' } }}
                >
                    {option.label}
                </Button>
            ))}
        </div>
    );
};

export default ShareButtons;
